import { composeAPI } from "../Common/api";
import vlanComposition from "./composition";

export const composedAPI = composeAPI(vlanComposition);
